import { firebaseAction } from "vuexfire";
import firebase from "firebase/app";
import { EventBus } from "../util/event-bus";
import constants from "@/config/constants";

const getAntiFrostTemp = function (zone) {
  return zone.type === constants.zoneTypes.acs
    ? constants.acsIceModeTemp
    : constants.iceModeTemp;
};

const fillFinalZonePayload = function (form, payload) {
  payload.type = form.type;
  payload.comfort = constants.defaultComfort;
  payload.eco = constants.defaultEco;
  payload.hilo_pilot = false;
  payload.mode = constants.modes.manual;
  payload.status = constants.status.none;
  payload.ice_mode = false;

  if (payload.type === constants.deviceTypes.acs) {
    payload.temp = constants.acsDefaultTemp;
    payload.eco = constants.acsDefaultEco;
    payload.comfort = constants.acsDefaultComfort;
    payload.evolution = false;
    payload.legionella_conf = null;
  } else {
    payload.two_hours = false;
    payload.presence_mode = false;
    payload.windows_opened = false;
  }

  return payload;
};

export default {
  namespaced: true,
  state: {
    current: {},
    devices: [],
  },
  getters: {},
  mutations: {
    setCurrent: function (state, zone) {
      state.current = zone;
    },

    addDeviceToZone: function (state, device) {
      //CHECK IF DEVICE BELONGS THE ZONE
      if (state.current.devices) {
        let deviceInZone = Object.keys(state.current.devices).find(
          (key) => key === device.serialnumber
        );

        if (deviceInZone) {
          let exists = state.devices.find(
            (x) => x.serialnumber === device.serialnumber
          );
          if (exists) {
            let index = state.devices.findIndex(
              (x) => x.serialnumber === device.serialnumber
            );
            state.devices[index] = device;
            EventBus.$emit("deviceUpdate");
          } else state.devices.push(device);
        }
      }
    },

    clearDevices: function (state) {
      state.devices = [];
    },
  },
  actions: {
    //BINDINGS

    bindCurrent: firebaseAction(({ bindFirebaseRef }, ref) => {
      return new Promise((resolve) => {
        bindFirebaseRef("current", ref, {
          readyCallback() {
            resolve();
          },

          errorCallback(error) {
            console.log(error);
          },
        });
      });
    }),

    setDevicesFinal: function (context, devices) {
      return new Promise((resolve) => {
        context.commit("clearDevices");
        if (devices !== undefined) {
          let zone = context.state.current;
          zone.devices = devices;
          let deviceIndex = 0;
          Object.keys(zone.devices).forEach((device) => {
            firebase
              .database()
              .ref("/devices/" + device)
              .on(
                "value",
                (item) => {
                  context.commit("addDeviceToZone", item.val());
                  deviceIndex++;
                  if (deviceIndex === Object.keys(zone.devices).length)
                    resolve();
                },
                () => {
                  deviceIndex++;
                  if (deviceIndex === Object.keys(zone.devices).length)
                    resolve();
                }
              );
          });
        } else resolve();
      });
    },

    setDevices: function (context) {
      return new Promise((resolve) => {
        context.commit("clearDevices");
        if (context.state.current.devices !== undefined) {
          let zone = context.state.current;
          let deviceIndex = 0;
          Object.keys(zone.devices).forEach((device) => {
            firebase
              .database()
              .ref("/devices/" + device)
              .on(
                "value",
                (item) => {
                  context.commit("addDeviceToZone", item.val());
                  deviceIndex++;
                  if (deviceIndex === Object.keys(zone.devices).length)
                    resolve();
                },
                () => {
                  deviceIndex++;
                  if (deviceIndex === Object.keys(zone.devices).length)
                    resolve();
                }
              );
          });
        } else resolve();
      });
    },

    setCurrent: function (context, id) {
      return new Promise((resolve, reject) => {
        function findZoneById(zones, id) {
          let match = null;
          for (let zone of zones) {
            if (zone.path.split("/")[zone.path.split("/").length - 1] === id) {
              match = zone;
              break;
            } else if (zone.zones !== undefined) {
              let result = findZoneById(Object.values(zone.zones), id);
              if (result !== null) {
                match = result;
                break;
              }
            }
          }
          return match;
        }

        let zone = findZoneById(
          Object.values(context.rootState.installations.current.zones),
          id
        );
        if (zone === null) reject();

        context.dispatch(
          "bindCurrent",
          firebase
            .database()
            .ref("/installations2")
            .child(context.rootState.installations.current[".key"])
            .child(zone.path)
        );

        resolve();
      });
    },

    //WIZARD

    addZone: function (context, form) {
      let id = firebase.database().ref().push().key;

      let payload = {
        name: form.name,
        meters: form.meters,
        final: form.final,
        path: "/zones/" + id,
        power: false,
        temp: constants.defaultTemp,
      };

      if (payload.final) payload = fillFinalZonePayload(form, payload);

      return firebase
        .database()
        .ref("/installations2")
        .child(context.rootState.installations.current[".key"])
        .child("zones")
        .child(id)
        .set(payload);
    },

    addSubZone: function (context, { parent, form }) {
      let id = firebase.database().ref().push().key;
      let payload = {
        name: form.name,
        meters: form.meters,
        final: form.final,
        path: parent.path + "/zones/" + id,
        power: parent.power,
        temp: constants.defaultTemp,
      };

      if (payload.final) payload = fillFinalZonePayload(form, payload);
      return firebase
        .database()
        .ref("/installations")
        .child(context.rootState.installations.current[".key"])
        .child(parent.path)
        .child("zones")
        .child(id)
        .set(payload);
    },

    updateZone: function (context, { zone, form }) {
      let payload = {
        name: form.name,
        meters: form.meters,
      };

      return firebase
        .database()
        .ref("/installations2")
        .child(context.rootState.installations.current[".key"])
        .child(zone.path)
        .update(payload);
    },

    //THERMOSTAT

    setStatus: function (context, { zone, status }) {
      let payload = {
        mode: constants.modes.manual,
        status: status,
        temp: zone[status],
      };

      if (status === constants.status.ice)
        payload.temp = getAntiFrostTemp(zone);

      //UPDATE ZONE
      firebase
        .database()
        .ref("installations2")
        .child(context.rootState.installations.current[".key"])
        .child(zone.path)
        .update(payload);

      //UPDATE CHILDREN
      if (zone.zones !== undefined) {
        Object.values(zone.zones).forEach((z) => {
          context.dispatch("setStatus", { zone: z, status: status });
        });
      }

      //UPDATE ALL DEVICES
      if (zone.devices !== undefined) {
        Object.keys(zone.devices).forEach((idDevice) => {
          firebase
            .database()
            .ref("devices")
            .child(idDevice)
            .once("value", (device) => {
              context.dispatch(
                "devices/setStatus",
                { device: device.val(), status },
                { root: true }
              );
            })
            .catch((error) => {
              console.log(error);
            });
        });
      }
    },

    async allDevicesHasSameTemp(context, { zone }) {
      let tempFlag = null;

      for (const idZone of Object.keys(zone.zones)) {
        if (tempFlag === null) tempFlag = zone.zones[idZone].temp;
        else if (tempFlag !== zone.zones[idZone].temp) return false;
      }

      return true;
    },

    async getZoneDevices(context, { zone }) {
      const devices = [];
      if (zone.devices !== undefined) {
        for (const idDevice of Object.keys(zone.devices)) {
          try {
            const snapshot = await firebase
              .database()
              .ref("devices")
              .child(idDevice)
              .once("value");
            const device = snapshot.val();

            if (device && device.data.type !== constants.deviceTypes.acs) {
              devices.push(device);
            }
          } catch (e) {}
        }
      }

      return devices;
    },

    setMode: function (context, { zone, mode }) {
      //UPDATE ZONE
      firebase
        .database()
        .ref("installations2")
        .child(context.rootState.installations.current[".key"])
        .child(zone.path)
        .update({ mode: mode });

      //UPDATE CHILDREN
      if (zone.zones !== undefined) {
        Object.values(zone.zones).forEach((z) => {
          context.dispatch("setMode", { zone: z, mode: mode });
        });
      }

      //UPDATE ALL DEVICES
      if (zone.devices !== undefined) {
        Object.keys(zone.devices).forEach((idDevice) => {
          firebase
            .database()
            .ref("devices")
            .child(idDevice)
            .once("value", (device) => {
              context.dispatch(
                "devices/setMode",
                { device: device.val(), mode },
                { root: true }
              );
            })
            .catch((error) => {
              console.log(error);
            });
        });
      }
    },

    async getZoneThermostatMode(context, { zone }) {
      if (zone.zones !== undefined) {
        let devices = [];

        for (const zone of Object.values(zone.zones)) {
          if (zone.zones !== undefined) {
            for (const z of Object.values(zone.zones)) {
              // get devices
              const subzoneDevices = await context.dispatch(
                "zones/getZoneDevices",
                { zone: z },
                { root: true }
              );
              devices = devices.concat(subzoneDevices);
            }
          }
          const zoneDevices = await context.dispatch(
            "zones/getZoneDevices",
            { zone: zone },
            { root: true }
          );
          devices = devices.concat(zoneDevices);
        }

        // remove undefined from devices array
        const filteredDevices = devices.filter(Boolean);

        const manual = filteredDevices.every((device) => {
          return device.data.mode === constants.modes.manual;
        });

        const auto = filteredDevices.every((device) => {
          return device.data.mode === constants.modes.auto;
        });

        if (manual === true) return false;
        else if (auto === true) return true;
        else return null;
      }

      return null;
    },

    setLockMode: function (context, { zone, value }) {
      let payload = { block_remote: false, block_local: value };

      //UPDATE ZONE
      firebase
        .database()
        .ref("installations2")
        .child(context.rootState.installations.current[".key"])
        .child(zone.path)
        .update(payload);

      //UPDATE CHILDREN
      if (zone.zones !== undefined) {
        Object.values(zone.zones).forEach((z) => {
          context.dispatch("setLockMode", { zone: z, value });
        });
      }

      //UPDATE ALL DEVICES
      if (zone.devices !== undefined) {
        Object.keys(zone.devices).forEach((idDevice) => {
          firebase
            .database()
            .ref("devices")
            .child(idDevice)
            .once("value", (device) => {
              context.dispatch(
                "devices/setLockMode",
                { device: device.val(), value },
                { root: true }
              );
            })
            .catch((error) => {
              console.log(error);
            });
        });
      }
    },

    setLockRemoteMode: function (context, { zone, value }) {
      let payload = { block_remote: value, block_local: false };

      //UPDATE ZONE
      firebase
        .database()
        .ref("installations2")
        .child(context.rootState.installations.current[".key"])
        .child(zone.path)
        .update(payload);

      //UPDATE CHILDREN
      if (zone.zones !== undefined) {
        Object.values(zone.zones).forEach((z) => {
          context.dispatch("setLockRemoteMode", { zone: z, value });
        });
      }

      //UPDATE ALL DEVICES
      if (zone.devices !== undefined) {
        Object.keys(zone.devices).forEach((idDevice) => {
          firebase
            .database()
            .ref("devices")
            .child(idDevice)
            .once("value", (device) => {
              context.dispatch(
                "devices/setLockRemoteMode",
                { device: device.val(), value },
                { root: true }
              );
            })
            .catch((error) => {
              console.log(error);
            });
        });
      }
    },

    setWindowMode: function (context, { zone, value }) {
      //UPDATE ZONE
      firebase
        .database()
        .ref("installations2")
        .child(context.rootState.installations.current[".key"])
        .child(zone.path)
        .update({ windows_open_mode: value });

      //UPDATE CHILDREN
      if (zone.zones !== undefined) {
        Object.values(zone.zones).forEach((z) => {
          context.dispatch("setWindowMode", { zone: z, value: value });
        });
      }

      //UPDATE ALL DEVICES
      if (zone.devices !== undefined) {
        Object.keys(zone.devices).forEach((idDevice) => {
          firebase
            .database()
            .ref("devices")
            .child(idDevice)
            .once("value", (device) => {
              context.dispatch(
                "devices/setWindowMode",
                { device: device.val(), value: value },
                { root: true }
              );
            })
            .catch((error) => {
              console.log(error);
            });
        });
      }
    },

    setLegionellaConfig: function (context, { zone, config }) {
      //UPDATE ZONE
      firebase
        .database()
        .ref("installations2")
        .child(context.rootState.installations.current[".key"])
        .child(zone.path)
        .update({ legionella_conf: config });

      //UPDATE CHILDREN
      if (zone.zones !== undefined) {
        Object.values(zone.zones).forEach((z) => {
          context.dispatch("setLegionellaConfig", { zone: z, config: config });
        });
      }

      //UPDATE ALL DEVICES
      if (zone.devices !== undefined) {
        Object.keys(zone.devices).forEach((idDevice) => {
          firebase
            .database()
            .ref("devices")
            .child(idDevice)
            .once("value", (device) => {
              context.dispatch(
                "devices/setLegionellaConfig",
                { device: device.val(), config: config },
                { root: true }
              );
            })
            .catch((error) => {
              console.log(error);
            });
        });
      }
    },

    setPower: function (
      context,
      { zone, power, discardAcs = false, installationId = null }
    ) {
      //UPDATE ZONE
      if (installationId === null) {
        installationId = context.rootState.installations.current[".key"];
      }
      if (!discardAcs || (discardAcs && zone.type !== constants.zoneTypes.acs))
        firebase
          .database()
          .ref("installations2")
          .child(installationId)
          .child(zone.path)
          .update({ power: power });

      //UPDATE CHILDREN
      if (zone.zones !== undefined) {
        Object.values(zone.zones).forEach((z) => {
          context.dispatch("setPower", {
            zone: z,
            power: power,
            discardAcs: discardAcs,
            installationId: installationId,
          });
        });
      }

      //UPDATE ALL DEVICES
      if (zone.devices !== undefined) {
        Object.keys(zone.devices).forEach((idDevice) => {
          firebase
            .database()
            .ref("devices")
            .child(idDevice)
            .once("value", (device) => {
              if (
                discardAcs &&
                device.val().data.type === constants.deviceTypes.acs
              )
                return false;
              context.dispatch(
                "devices/setPower",
                { device: device.val(), power },
                { root: true }
              );
            })
            .catch((error) => {
              console.log(error);
            });
        });
      }
    },

    setTemperature: function (
      context,
      { zone, temperature, discardAcs = false }
    ) {
      let payload = {
        temp: temperature,
        mode: constants.modes.manual,
        status: constants.status.none,
      };

      if (
        (payload.temp === constants.iceModeTemp &&
          zone.type === constants.zoneTypes.radiator) ||
        (payload.temp === constants.iceModeTemp &&
          zone.type === constants.zoneTypes.oval_towel)
      )
        payload.status = constants.status.ice;
      else if (
        payload.temp === constants.acsIceModeTemp &&
        zone.type === constants.zoneTypes.acs
      )
        payload.status = constants.status.ice;

      if (zone.eco && payload.temp === zone.eco)
        payload.status = constants.status.eco;
      else if (zone.comfort && payload.temp === zone.comfort)
        payload.status = constants.status.comfort;

      if (
        !discardAcs ||
        (discardAcs && zone.type !== constants.zoneTypes.acs)
      ) {
        firebase
          .database()
          .ref("installations2")
          .child(context.rootState.installations.current[".key"])
          .child(zone.path)
          .update(payload);
      }

      //UPDATE CHILDREN
      if (zone.zones !== undefined && temperature !== null) {
        Object.values(zone.zones).forEach((z) => {
          context.dispatch("setTemperature", {
            zone: z,
            temperature: temperature,
            discardAcs: discardAcs,
          });
        });
      }

      //UPDATE ALL DEVICES
      if (zone.devices !== undefined) {
        Object.keys(zone.devices).forEach((idDevice) => {
          firebase
            .database()
            .ref("devices")
            .child(idDevice)
            .once("value", (device) => {
              let deviceType = device.val().data.type;

              if (
                discardAcs &&
                (deviceType === constants.deviceTypes.acs ||
                  deviceType === constants.deviceTypes.floor)
              )
                return false;
              context.dispatch(
                "devices/setTemperature",
                { device: device.val(), temperature },
                { root: true }
              );
            })
            .catch((error) => {
              console.log(error);
            });
        });
      }
    },

    //SETTINGS

    setAdvancedSettings: function (context, { zone, form }) {
      let payload = {
        pilot_mode: form.pilot_mode,
        eco: form.eco,
        comfort: form.comfort,
        block_remote: form.block_remote,
        block_local: form.block_local,
        ice_mode: form.ice_mode,
      };

      if (zone.status !== constants.status.none) {
        if (zone.status === constants.status.ice)
          payload.temp = getAntiFrostTemp(zone);
        // IS IT NECESSARY?
        else payload.temp = form[zone.status];
      }

      if (zone.type === constants.zoneTypes.acs) {
        payload.legionella_conf = form.legionella_conf;
      } else if (
        zone.type === constants.zoneTypes.radiator ||
        zone.type === constants.zoneTypes.oval_towel ||
        zone.type === constants.zoneTypes.towel
      ) {
        payload.windows_open_mode = form.windows_open_mode;
        payload.pir_mode = form.pir_mode;
        payload.two_hours = form.two_hours;
      }

      // hotel
      if (!form.hotel_mode) {
        payload.user_mode = false;
      } else {
        payload.user_mode = true;
        payload.block_remote = true;
      }

      // adelanto
      if (form.adelanto_enable !== undefined) {
        payload.adelanto_enable = form.adelanto_enable;
      }

      //UPDATE ZONE
      firebase
        .database()
        .ref("installations2")
        .child(context.rootState.installations.current[".key"])
        .child(zone.path)
        .update(payload);

      //UPDATE DEVICES
      if (zone.devices !== undefined) {
        Object.keys(zone.devices).forEach((idDevice) => {
          firebase
            .database()
            .ref("devices")
            .child(idDevice)
            .once("value", (device) => {
              context.dispatch(
                "devices/setAdvancedSettings",
                { device: device.val(), form },
                { root: true }
              );
            })
            .catch((error) => {
              console.log(error);
            });
        });
      }
    },

    //PROGRAM
    setProgram: function (context, { zone, program }) {
      return new Promise((resolve) => {
        let payload = {
          schedule: program,
        };

        firebase
          .database()
          .ref("installations2")
          .child(context.rootState.installations.current[".key"])
          .child(zone.path)
          .update(payload);

        //UPDATE DEVICES
        if (zone.devices !== undefined) {
          Object.keys(zone.devices).forEach((idDevice) => {
            firebase
              .database()
              .ref("devices")
              .child(idDevice)
              .once("value", (device) => {
                context.dispatch(
                  "devices/setProgram",
                  { device: device.val(), program },
                  { root: true }
                );
              })
              .catch((error) => {
                console.log(error);
              });
          });
        }

        resolve();
      });
    },

    //STATISTICS

    setStatistics(context, payload) {
      //GET DEVICES
      let zone = context.state.current;
      let devices = [];

      function getDevices(zone) {
        if (
          zone.zones === undefined &&
          zone.final &&
          zone.devices !== undefined
        ) {
          //ADD DEVICES
          Object.keys(zone.devices).forEach((device) => {
            devices.push(device);
          });
        }
        if (zone.zones !== undefined)
          Object.values(zone.zones).forEach((z) => getDevices(z));
      }

      getDevices(zone);

      let discardAcs = zone.type !== constants.zoneTypes.acs;

      //ACTION ON STATISTICS WITH DEVICES AND DATE
      return context.dispatch(
        "statistics/setData",
        {
          filters: payload,
          devices: devices,
          discardAcs: discardAcs,
        },
        { root: true }
      );
    },

    //WARMUP

    updateFloorDevices({ state, dispatch }) {
      state.devices.forEach((device) => {
        if (device.data.type === constants.deviceTypes.floor)
          dispatch("devices/updateWithWarmUpInfo", device, { root: true });
      });
    },
  },
};
